document.addEventListener('DOMContentLoaded', function() {
    const wordleGrid = document.getElementById("wordle-grid");
    const hint1Btn = document.getElementById("hint1-btn");
    const hint1Text = document.getElementById("hint1");
    const hint2Text = document.getElementById("hint2");
    const shareBtn = document.getElementById("share-btn");
    
    let currentWord = '';
    let hints = [];
    
    // Use the published Google Sheet CSV URL
    const googleSheetCSVURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vT3Kps3C4b1Udg4CYj-TSlvwJtvWOr_kOjbd8lSjXj_vyDG2QqsDh3zuM08KRzpl1Gs5etQobeo2Vzp/pub?output=csv";
    
    // Fetch the current word and hints based on the current date from Google Sheets
    async function fetchWordData() {
        const currentDate = new Date().toISOString().split('T')[0]; // Get the current date in YYYY-MM-DD format
        
        // Fetch the CSV data from the published Google Sheet
        const response = await fetch(googleSheetCSVURL);
        const csvText = await response.text();

        // Parse CSV data (assuming it's simple CSV data)
        const rows = csvText.split("\n").map(row => row.split(","));
        
        // Find today's word based on the date
        let todayData = rows.find(row => row[0] === currentDate);

        if (todayData) {
            const [date, word, hint1, hint2, explanation] = todayData;
            currentWord = word;
            hints = [hint1, hint2];

            // Display hints and initialize the grid
            hint1Text.innerHTML = hint1;
            hint2Text.innerHTML = hint2;
            
            renderGrid();
        }
    }

    // Render the Wordle grid with placeholders
    function renderGrid() {
        wordleGrid.innerHTML = ''; // Clear the grid
        for (let i = 0; i < 5; i++) {
            const letterBox = document.createElement("div");
            letterBox.classList.add("letter-box");
            wordleGrid.appendChild(letterBox);
        }
    }

    // Reveal Hint 1 when button is clicked
    hint1Btn.addEventListener('click', function() {
        hint1Text.style.display = 'block';
    });

    // Function to handle guessing logic, feedback, and validation
    function handleGuess(guess) {
        if (guess.length !== 5) return; // Ensure valid word guess
        let feedback = [];
        for (let i = 0; i < 5; i++) {
            if (guess[i] === currentWord[i]) {
                feedback.push('green');
            } else if (currentWord.includes(guess[i])) {
                feedback.push('yellow');
            } else {
                feedback.push('gray');
            }
        }
        // Update grid feedback
        updateGridFeedback(feedback);
    }

    // Function to update grid colors based on feedback
    function updateGridFeedback(feedback) {
        const letterBoxes = document.querySelectorAll(".letter-box");
        feedback.forEach((color, index) => {
            letterBoxes[index].style.backgroundColor = color;
        });
    }

    // Share functionality (social media and link copy)
    shareBtn.addEventListener('click', function() {
        // Trigger social sharing here
        alert("Sharing functionality will be implemented here!");
    });

    fetchWordData();
});
